<template>
    <div class="dorms">
        <div class="row">
            <div class="filter-secition">
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="">Haber Ara</label>
                        <div class="input-group">
                            <input class="form-control custom-input" type="text" placeholder="Haber Başlığı" v-model="search">
                            <span class="input-group-btn">
                                <a class="btn btn-primary" style="height: 45px;" @click="searchFilter">
                                    <i class="fa fa-search" style="vertical-align: -webkit-baseline-middle;"></i> 
                                </a>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="widget">
                    <div class="table-area">
                        <div class="widget-title">
                            <h3><i :class="icon"> </i> {{ tableName }}</h3>
                            <span>{{ tableDesc }}</span>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th>Başlık</th>
                                        <th>Görüntülenme</th>
                                        <th>İşlemler</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in items" :key="item.id">
                                        <td>{{ item.title }}</td>
                                        <td>{{ item.view_count }}</td>
                                        <td>
                                            <router-link :to="{ name: 'news.update', params: {id: item.id} }" class="btn btn-primary btn-xs"> <span>Düzenle</span></router-link> / <button class="btn btn-danger btn-xs"> Sil</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="10" @paginate="fetchPosts()"></pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Pagination from '@/components/layouts/Pagination'
    export default {
        components: { Pagination },
        data () {
            return {
                tableName: 'Haberler Tablosu',
                icon: 'fa fa-building',
                tableDesc: '',
                api: 'news',
                items: [],
                university: '',
                universities: [],
                search: '',
                pagination: {
                    'current_page': 1
                }
            }
        },
        mounted () {
            this.fetchPosts()
        },
        methods: {
            fetchPosts() {
                this.$Progress.start()
                this.axios.get(this.api, { params: {
                    page: this.pagination.current_page,
                    title: this.search,
                }}).then(response => {
                    this.pagination = response.data.pagination;
                    this.items = response.data.data.data
                    this.$Progress.finish()
                })
            },
            searchFilter() {
                this.$Progress.start()
                this.axios.get(this.api, {params: {
                    title: this.search
                }}).then(response => {
                    this.items = response.data.data.data
                    this.pagination = response.data.pagination;
                    this.$Progress.finish()
                })
            },
        },
    }
</script>

<style scoped>

</style>